import React, { useEffect, useRef } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import { getUser, setReturnURL } from "../../../utils/commonfunction";
import { ROLE } from "../../../utils/Constants";
import offlineImg from "../../../assets/Offline.jpeg";

const BusinessPrivateRoute = ({ component: Component }) => {
  const userData = getUser(ROLE.BUSINESS);
  const offlineModalOpen = useRef(null);
  const offlineModalClose = useRef(null);
  const navigate = useNavigate();

  const isNetworkConnected = async () => {
    const response = await fetch("https://www.google.com/", { mode: "no-cors" });
    offlineModalClose.current?.click();
  };

  const handleOnline = () => {
    offlineModalClose.current?.click();
  };

  const handleOffline = () => {
    offlineModalOpen.current?.click();
  };

  useEffect(() => {
    window.addEventListener("online", handleOnline);
    window.addEventListener("offline", handleOffline);

    return () => {
      window.removeEventListener("online", handleOnline);
      window.removeEventListener("offline", handleOffline);
    };
  }, []);


  useEffect(()=>{
    if(Object.keys(userData).length && userData.token && userData.role === ROLE.BUSINESS && userData.isCompleteProfile===false){
      console.log('redirect');
      navigate('/business/complete-profile/business-description')
    }
  }, [])

  return (
    <>
      {/* Hidden button to trigger Bootstrap modal programmatically */}
      <button type="button" ref={offlineModalOpen} className="btn btn-primary d-none" data-bs-toggle="modal" data-bs-target="#staticBackdrop"></button>

      {/* Offline Modal */}
      <div className="modal fade" id="staticBackdrop" data-bs-backdrop="static" data-bs-keyboard="false" tabIndex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true">
        <div className="modal-dialog modal-dialog-centered modal-lg">
          <div className="modal-content offline-modal-content">
            <button type="button" className="btn-close d-none" ref={offlineModalClose} data-bs-dismiss="modal" aria-label="Close"></button>
            <div className="modal-body">
              <div className="w-100 d-flex justify-content-center py-5">
                <div className="text-center">
                  <img className="offline-modal-img" src={offlineImg} alt="Offline" style={{ maxWidth: "5rem" }} />
                  <h3 className="fs-22">No Internet Connection</h3>
                  <p>Check your internet connection and try again.</p>
                  <button onClick={isNetworkConnected} className="btn btn-primary mt-2">
                    Try Again
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Route Protection Logic */}
      {(function () {
        if (Object.keys(userData).length && userData.token && userData.role === ROLE.BUSINESS) {
          return <Component />;
        } else {
          setReturnURL(ROLE.BUSINESS);
          return <Navigate to="/business/login" />;
        }
      })()}
    </>
  );
};

export default BusinessPrivateRoute;
